import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import { useNavigate } from "react-router-dom";
import userStore from "../../../zustand/userStore";
import { apiKeyHeader } from "../../../configs/ApiKeys";

const RegisteredQuizzes2 = () => {
  const [quizzes, setQuizzes] = useState([]);
  const [now, setNow] = useState(Date.now());
  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const [popUp, setPopUp] = useState(false);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [msg, setMsg] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("");
  // const [quizDetails, setQuizDetails] = useState({
  //   show: false,
  //   quiz_id: "",
  //   start_date: "",
  // });
  useEffect(() => {
    fetchAll();
  }, []);

  useEffect(() => {
    // Timer updates every second
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const userData = userStore((state) => state.user);

  const fetchAll = async () => {
    try {
      const quizRes = await axios.get(
        // `/participant/registered-quizzes?userId=${userData.id}`
        // `/participant/registered-quizzes?userId=${userData.id}`,
        `/registered-quizzes?userId=${userData.id}`
      );
      // console.log("Fetched Quizzes:", quizRes.data);
      setQuizzes(quizRes.data.quizzes);
    } catch (err) {
      console.error("Error fetching quiz data:", err);
    }
  };

  // console.log("quizzes", quizzes);
  const filteredQuizzes = quizzes?.filter((q) => {
    // 1️⃣ Apply Quiz Type Filter
    if (filter && q.quiz_type !== Number(filter)) {
      return false;
    }

    // 2️⃣ Apply Search Filter
    if (searchTerm) {
      const term = searchTerm.toLowerCase();

      const matchesSearch =
        String(
          q.quiz_type === 1
            ? "Live Quiz"
            : q.quiz_type === 2
            ? "Practice Quiz"
            : q.quiz_type === 3
            ? "Thematic Quiz"
            : "-"
        )
          .toLowerCase()
          .includes(term) ||
        String(q.title).toLowerCase().includes(term) ||
        String(q.status).toLowerCase().includes(term) ||
        new Date(q.start_date)
          .toLocaleString("en-IN")
          .toLowerCase()
          .includes(term) ||
        String(q.id).toLowerCase().includes(term);

      if (!matchesSearch) return false;
    }

    return true; // no filters OR passed filters
  });

  // console.log("filteredQuizzes", filteredQuizzes);

  function formatUTCToIST(input) {
    const date = new Date(input);

    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };

    const parts = date.toLocaleString("en-GB", options).replace(",", "");
    // en-GB gives dd/mm/yyyy by default

    // Convert "11/12/2025 10:35 am" → "11/12/2025 at 10:35 AM"
    const [d, t, a] = parts.split(" ");
    return `${d} at ${t} ${a.toUpperCase()}`;
  }

  return (
    <div style={{ height: "100vh" }}>
      <div>
        <h3 style={{ fontSize: "16px", marginTop: "1%" }}>
          <strong>Registered Quizzes</strong>
        </h3>
        {/* <h2 className="text-center-new">Registered Quizzes</h2> */}
        {popUp && selectedQuiz && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                background: "#fff",
                padding: "30px",
                borderRadius: "10px",
                textAlign: "center",
                width: "800px",
                height: "90vh",
                overflow: "auto",
              }}
            >
              <button
                className="btn btn-danger mt-3"
                onClick={() => {
                  setPopUp(false);
                  setSelectedQuiz(null);
                  setCode("");
                }}
                style={{ float: "right" }}
              >
                Close
              </button>
              <br />
              <div
                style={{
                  padding: "1rem",
                  lineHeight: "1.6",
                  fontSize: "15px",
                  textAlign: "left",
                }}
              >
                <p>
                  <strong>
                    Please enter the registration code to start the quiz
                  </strong>
                </p>
                <input
                  type="text"
                  value={code}
                  className="form-input"
                  onChange={(e) => setCode(e.target.value)}
                />
                {selectedQuiz &&
                  (() => {
                    const startTime = new Date(
                      selectedQuiz.start_date
                    ).getTime();
                    const timeDiff = startTime - now;

                    if (timeDiff <= 0) {
                      return (
                        <p style={{ color: "green" }}>Quiz has started!</p>
                      );
                    }

                    const minutes = Math.floor(
                      (timeDiff % (1000 * 60 * 60)) / (1000 * 60)
                    );
                    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

                    return (
                      <p style={{ color: "brown" }}>
                        Quiz starts in {minutes > 0 && `${minutes}m`} {seconds}s
                      </p>
                    );
                  })()}

                <br />
                <button
                  className="btn btn-primary mt-3"
                  onClick={async () => {
                    // ✅ 1. Check if quiz already started
                    const quizStart = new Date(selectedQuiz.start_date); // must be a valid date string
                    const now = new Date();

                    // if the quiz start time is now or in the past
                    if (quizStart <= now) {
                      alert("Quiz has already started!");
                      setCode("");
                      setPopUp(false);
                      return; // ⬅️ stop here – don’t call the API or navigate
                    }

                    // ✅ 2. Safe to call the API
                    try {
                      // console.log("Selected Quiz before verify:", selectedQuiz);
                      // console.log("Quiz Type Sent:", selectedQuiz?.quiz_type);

                      const res = await axios.post(
                        // "/participant/verify-entry-code",
                        // "/participant/verify-entry-code",
                        "/verify-entry-code",
                        {
                          quiz_id: selectedQuiz.id,
                          code,
                          user_id: Number(userData.id),
                          quiz_type: selectedQuiz.quiz_type,
                        }
                      );

                      if (res.data?.code_verification_status === true) {
                        setMsg("Verified successfully!");
                        setPopUp(false);
                        sessionStorage.setItem(
                          "currentQuiz",
                          JSON.stringify(selectedQuiz)
                        );
                        navigate(`/quiz-dashboard/ready/${selectedQuiz.id}`, {
                          state: {
                            startTime: selectedQuiz.start_date,
                            quiz_id: Number(selectedQuiz.id),
                            quizType: Number(selectedQuiz.quiz_type),
                            theme_group_id: selectedQuiz?.group_id,
                          },
                        });
                      } else {
                        setMsg("Failed to join quiz. Invalid code.");
                      }
                    } catch (err) {
                      setMsg("Failed to join quiz. Invalid code.");
                    }
                    // try {
                    //   const res = await axios.post(
                    //     `/participant/verify-entry-code`,
                    //     {
                    //       quiz_id: selectedQuiz.id,
                    //       code,
                    //       user_id: Number(userData.id),
                    //     }
                    //   );
                    //   console.log(res.data);
                    //   if (res.data?.code_verification_status === true) {
                    //     setMsg("Verified successfully!");
                    //     // alert("Verified successfully");
                    //     setPopUp(false);
                    //     // setQuizDetails({
                    //     //   show: true,
                    //     //   quiz_id: selectedQuiz.id,
                    //     //   start_date: selectedQuiz.start_date,
                    //     // });
                    //     navigate(`/quiz-new/ready/${selectedQuiz.id}`, {
                    //       state: {
                    //         startTime: selectedQuiz.start_date,
                    //         quiz_id: Number(selectedQuiz.id),
                    //       },
                    //     });
                    //   }
                    //   if (res.data?.code_verification_status === false) {
                    //     setMsg("Failed to join quiz. Invalid code.");
                    //   }
                    // } catch (err) {
                    //   setMsg("Failed to join quiz.Invalid code.");
                    // }
                  }}
                >
                  Join Quiz
                </button>
                <p style={{ color: "red" }}>{msg}</p>
              </div>
            </div>
          </div>
        )}
        {quizzes.length > 0 && (
          <div
            style={{
              position: "sticky",
              top: 0,
              background: "white",
              zIndex: 10,
              padding: "8px",
              display: "flex",
              gap: "2%",
              fontSize: "16px",
            }}
          >
            <p style={{ fontSize: "16px" }}>
              <strong>Quiz Type</strong>
            </p>
            <select
              className="form-input small-select"
              onChange={(e) => setFilter(e.target.value)}
            >
              <option value="">-- Select --</option>

              <optgroup label="Live">
                <option value="1">Academic Quiz</option>
                <option value="3">Thematic Quiz</option>
              </optgroup>
            </select>
            <p>
              <strong>Search</strong>
            </p>
            <input
              type="text"
              className="form-control"
              value={searchTerm}
              style={{ width: "25%", height: "5vh" }}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        )}
        {filteredQuizzes?.length > 0 && (
          <p>
            <strong>Matched Records Count : </strong>
            {filteredQuizzes?.length}
          </p>
        )}
        {filteredQuizzes.length ? (
          <div style={{ height: "60vh", overflow: "auto" }}>
            <table className="table-new">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Total Questions</th>
                  <th>Duration per question</th>
                  <th>Registration Start</th>
                  <th>Registration End</th>
                  <th>Quiz Start</th>
                  {/* <th>Registration Code</th> */}
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredQuizzes.map((quiz) => {
                  const quizStart = new Date(quiz.start_date).getTime();
                  const timeDiff = quizStart - now; // milliseconds
                  const hasStarted = now > quizStart;
                  const isEnabled = timeDiff <= 5 * 60 * 1000 && !hasStarted;

                  const absDiff = Math.abs(timeDiff);

                  const days = Math.floor(absDiff / (1000 * 60 * 60 * 24));
                  const hours = Math.floor(
                    (absDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                  );
                  const minutes = Math.floor(
                    (absDiff % (1000 * 60 * 60)) / (1000 * 60)
                  );
                  const seconds = Math.floor((absDiff % (1000 * 60)) / 1000);

                  return (
                    <tr key={quiz.id}>
                      <td>{quiz.title}</td>
                      <td>{quiz.total_questions}</td>
                      <td>{quiz.duration_per_question}</td>
                      <td>
                        {" "}
                        {formatUTCToIST(quiz.registration_start_date)}
                        {/* {new Date(
                          quiz.registration_start_date
                        ).toLocaleString()} */}
                      </td>
                      <td>
                        {formatUTCToIST(quiz.registration_end_date)}
                        {/* {new Date(quiz.registration_end_date).toLocaleString()} */}
                      </td>
                      <td>{formatUTCToIST(quiz.start_date)}</td>
                      {/* {new Date(quiz.start_date).toLocaleString()}</td> */}
                      {/* <td>{quiz.quiz_entry_code}</td> */}
                      <td>
                        <span
                          className={` ${
                            quiz.status === "completed"
                              ? "badge-success"
                              : quiz.status === "ongoing"
                              ? "badge-info"
                              : "badge-warning"
                          }`}
                          style={{ padding: "8px", borderRadius: "4px" }}
                        >
                          {quiz.status}
                        </span>
                      </td>
                      <td>
                        <button
                          // disabled={!isEnabled}
                          onClick={() => {
                            if (isEnabled) {
                              // console.log("🟢 Quiz clicked:", quiz); // ✅ Add here
                              setSelectedQuiz(quiz);
                              setTimeout(() => {
                                // console.log("🟢 After setSelectedQuiz:", quiz);
                                setPopUp(true);
                              }, 0); // ensures state updates before popup opens
                            }
                          }}
                          style={{
                            padding: "10px 20px",
                            borderRadius: "6px",
                            fontWeight: "600",
                            fontSize: "14px",
                            border: "none",
                            cursor: isEnabled ? "pointer" : "not-allowed",
                            backgroundColor: isEnabled ? "#10B981" : "#E5E7EB",
                            color: isEnabled ? "#FFFFFF" : "#6B7280",
                            transition: "background-color 0.3s ease",
                            minWidth: "220px",
                            textAlign: "center",
                          }}
                          title={
                            quiz.status === "ongoing" &&
                            "You cannot participate in the quiz as it has already started.Better Luck next time"
                          }
                        >
                          {quiz.status === "completed"
                            ? "Quiz Ended"
                            : hasStarted
                            ? "Quiz already started"
                            : isEnabled
                            ? "I am ready"
                            : `Quiz will start in ${days}d ${hours}h ${minutes}m ${seconds}s`}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No quizzes available.</p>
        )}
        <style>
          {`.small-select {

    width: 18vh !important;
    height: 6vh !important;
  }`}
        </style>
      </div>
    </div>
  );
};

export default RegisteredQuizzes2;
